import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

import { useModal } from '../Modal/ModalContext';
import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

const ApparatusSROTable = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [users, setUsers] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const [role, setRole] = React.useState('');
    const [userId, setUserId] = React.useState('');

    const [limitForView, setLimitForView] = React.useState(50);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    const [importantAccountData, setImportantAccountData] = React.useState([]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };
    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();

        axios.get('/api/get-important-account-data', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setImportantAccountData(response.data);
        }).catch((error) => {
            console.error('Ошибка при получении данных пользователя:', error);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    React.useEffect(() => {
        setLoading(true);

        const token = localStorage.getItem('token');
        axios.get(`/api/get-all-workers?approval=Активен&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setUsers([]);
                setWarning('Пользователи в системе отсутствуют');
                setVisibilityBtn(false);
            } else {
                setUsers(response.data);
                setWarning('');
                setVisibilityBtn(response.data.length >= limitForView);
            }
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        }).finally(() => {
            setReload(false);
            setLoading(false);
        })
    }, [reload]);

    const changeAccess = (userIdForChange) => {
        const token = localStorage.getItem('token');

        
        axios.put(`/api/change-access?userId=${userIdForChange}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setReload(true);
            if (response.data == 'На рассмотрении') {
                openTimeModal('Доступ отозван', 'success');
            } else {
                openTimeModal('Доступ разрешён', 'success');
            }
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось изменить параметр доступа к системе. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    };

    React.useEffect(() => {
        if (role && userId) {
            const token = localStorage.getItem('token');

            axios.put('/api/change-role', {}, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    role: role,
                    userId: userId,
                },
            })
            .then(() => {
                openTimeModal('Тип учётной записи успешно изменён', 'success');
            }).catch((error) => {
                console.error(error);
                openTimeModal(`Не удалось изменить тип учётной записи. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            })
        }
    }, [role, userId]);

    const changeRole = (e, userIdForChangeRole) => {
        setRole(e.target.value); 
        setUserId(userIdForChangeRole);
    };

    return (
        <div className='pageWrapper'>
            <div className='tableContainer'>
                <div className='tableHeaderWrapper'>
                    <div className='tableHeader' style={{gridTemplateColumns: '1fr 1fr 1fr 1fr'}}>
                        <div>ФИО</div>
                        <div>Электронная почта</div>
                        <div>Тип учетной записи</div>
                        <div>Действие</div>
                    </div>
                </div>
                {loading ? <LoadingLines count='5' heightLine='72' />
                : warning ? <WarningPanel text={warning} inTable={true} buttonText='Повторить попытку' buttonAction={() => setReload(true)} />
                : users.map((user) => (
                    <div className='tableRow nonActive' key={user.id} style={{gridTemplateColumns: '1fr 1fr 1fr 1fr'}}>
                        <div className='aWithLink' style={{cursor: 'pointer'}} onClick={() => navigate(`/account/${user.id}`, { state: { from: location.pathname + location.search + location.hash } })}>{user.lastname} {user.firstname} {user.surname}</div>
                        <div><a href={`mailto:${user.email}`} className='aWithLink'>{user.email}</a></div>
                        {(user.me == true || (importantAccountData.access_level !== 'Администратор' && user.access_level == 'Администратор')) ? 
                        <>
                            <div>
                                <select value="Недоступно" style={{cursor: 'default'}} disabled>
                                    <option value="Недоступно" disabled>Недоступно</option>
                                </select>
                                <p className='inTableRowDescription'>
                                    {importantAccountData.access_level !== 'Администратор' ? <>
                                        Данная учётная запись защищена
                                    </> : <>
                                        Вы не можете изменить тип своей учётной записи
                                    </>}
                                </p>
                            </div>
                            <div>
                                <button type='button' className='button miniButton unactive'>Отозвать доступ</button>
                            </div>
                        </> : 
                        <>
                            <div>
                                <select 
                                    onChange={(e) => changeRole(e, user.id)} 
                                    defaultValue={user.role || ""}
                                >
                                    <option value="" disabled>Изменить тип аккаунта</option>
                                    <option value="Арбитражный управляющий">Арбитражный управляющий</option>
                                    <option value="АппаратСРО">АппаратСРО</option>
                                </select>
                                <p className='inTableRowDescription'>Нажмите и выберите нужный тип учетной записи для изменения</p>
                            </div>
                            <div>
                                <button type='button' className='button miniButton' onClick={() => changeAccess(user.id)}>Отозвать доступ</button>
                            </div>
                        </>}
                    </div>
                ))}
                {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}>Загрузить ещё</button></span>}
            </div>
        </div>
    )
}

export default ApparatusSROTable;